import Column from '@components/Column';
import Divider from '@components/Divider';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import dayjs from 'dayjs';

interface Props {
    title: string;
    startAt: Date;
    endAt: Date;
}

function NoticeHeader({ title, startAt, endAt }:Props) {
    return (
        <Container as='section'
            fullWidth
            spacing={16}>
            <TitleText size='2xl' fontWeight='bold'>
                {title}
            </TitleText>
            <Text color={colors.gray6}>
                {dayjs(startAt).format('YYYY.MM.DD')}-{dayjs(endAt).format('YYYY.MM.DD')}
            </Text>
            <Divider isThin />
        </Container>
    );
}

const Container = styled(Column)`
    padding: 28px 20px 16px;
`;

const TitleText = styled(Text)`
    white-space: wrap;
    width: 100%;
    word-break: break-word;
`;

export default NoticeHeader;
